module.exports = __webpack_public_path__ + "static/commerce2x-commerce-one-bb7d31e2148d6a7052c846c7c3ebf500.jpg";